import React, { useEffect, useState } from "react";
import CookieAPI from "../../api/CookieAPI";
import { useParams } from "react-router-dom";
import { toImagePath } from "../../utils/globalFunctions";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";

function CookieProlicy() {
    const { type } = useParams();
    const { i18n } = useTranslation();
    const [data, setData] = useState([]);
    
    const fetchData = async () => {
        try {
            const response = await (i18n.language === 'en' ? CookieAPI.getDetailCookieEn() : CookieAPI.getDetailCookie());
            const filteredData = response.data.filter(item => item.pagename === type);
            setData(filteredData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [type, i18n.language]);

    return (
        <main className="site-main">
            {data.map((item, index) => (
                <React.Fragment key={index}>
                    <section className="banner bg-news-intro">
                        <img
                            className="banner-image w-full"
                            src="/images/banner_cookie.jpeg"
                            alt="Hero Banner"
                        />
                        <div className="headline text-center">
                            <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">
                                {item.privacyitem.head}
                            </h1>
                        </div>
                    </section>
                    {/* Main Content */}
                    <section className="content p-4 md:p-8 bg-gray-50">
                        <div className="content-container box-news-container">
                            <div className="content-header w-full">
                                <div className="header-content">
                                    <h2 className="header-content__title">
                                        {item.privacyitem.title}
                                    </h2>
                                </div>
                                <div className="md:px-12">
                                    <div className="text-md text-[#3D3D3D] font-medium py-6 px-4">
                                        <div dangerouslySetInnerHTML={{ __html: item.privacyitem.pagedetail }} />
                                    </div>
                                </div>
                                {item?.privacyitem?.pdflink?.path && (
                                    <div className="flex flex-col items-start mt-8">
                                    <iframe
                                        src={toImagePath(item?.privacyitem?.pdflink?.path)}
                                        width="100%"
                                        height="600px"
                                        className="shadow-lg border border-gray-300 rounded-lg"
                                    />
                                    <div className="mt-5 flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
                                        <p className="text-[#272974] font-medium text-lg">
                                            {item?.privacyitem?.pdftitle}
                                        </p>
                                        <a
                                            href={toImagePath(item?.privacyitem?.pdflink?.path)}
                                            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded-full shadow-md transition duration-300"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <FiDownload /> ดาวน์โหลด
                                        </a>
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </section>
                </React.Fragment>
            ))}
        </main>
    );
}

export default CookieProlicy;
